import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessTimelineRoute: InvariantJiraRoute = {
	name: 'classic-business-timeline',
	path: '/jira/core/projects/:projectKey/timeline',
	exact: true,
};
